// src/utils/firebase.ts
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDuTxCTF3jBWmNys3UTA3HTTmwV8ZrL9Bg",
  authDomain: "home-spector-ai.firebaseapp.com",
  projectId: "home-spector-ai",
  storageBucket: "home-spector-ai.firebasestorage.app",
  messagingSenderId: "111765703267",
  appId: "1:111765703267:web:5cb772ce715eca6ba0c656"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);  // Add this export